import React, { useState } from 'react';
import { TextField, Button, Paper } from '@mui/material';
import './ClientPortal.css';
import circle from './c5.png';



import Waves from './Waves';
const ClientPortal = () => {
  const [clientId, setClientId] = useState('');
  const [error, setError] = useState('');

  const handleLogin = (e) => {
    e.preventDefault();
    if (clientId.trim() === '60175') {
      window.location.href = "https://clientellexample.web.app";
    } else {
      setError('Invalid Client ID');
    }
  };

  return (
    <div
      className='outerDiv'
      style={{
        width: '100vw',
        height: '100vh',
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        overflow: 'hidden',
      }}
    >
      {/* Ripple background behind the form */}
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          zIndex: 0,
          pointerEvents: 'none',
        }}
      >



        <Waves
          lineColor="#336699"
          backgroundColor="rgba(0, 0, 0, 0.8)"
          waveSpeedX={0.01}
          waveSpeedY={0.01}
          waveAmpX={40}
          waveAmpY={40}
          friction={0.9}
          tension={0.01}
          maxCursorMove={120}
          xGap={12}
          yGap={6}
        />

      </div>

      <div
        className="clientPortalContainer"
        style={{ position: 'relative', zIndex: 1 }}
      >
        <Paper
          elevation={3}
          className="formPaper"
          style={{
            backgroundColor: '#ffffff',
            borderRadius: '12.5px',
            boxShadow: '0 12px 16px rgba(0, 0, 0, 0.7)',
            padding: '25px',
            maxWidth: '650px',
            margin: '20px',
          }}
        >
          <div>
            <img src={circle} alt="Circle" className="circleImage" />
          </div>
          <div
            className="formTitle"
            style={{ fontFamily: 'Medium', color: '#336699', padding: '0px' }}
          >
            Client Portal
          </div>
          <div className="formDescription" style={{ fontFamily: 'Regular' }}>
            Access your portal sign in page from here!
          </div>
          <form className="form" onSubmit={handleLogin}>
            <TextField
              label="Client ID"
              variant="outlined"
              fullWidth
              margin="normal"
              value={clientId}
              onChange={(e) => setClientId(e.target.value)}
              className="formField"
              inputProps={{ style: { fontFamily: 'Regular' } }}
              InputLabelProps={{ style: { fontFamily: 'Regular' } }}
              error={!!error}
              helperText={error}
            />
            <Button
              variant="contained"
              color="primary"
              type="submit"
              className="submitButton"
              style={{ fontFamily: 'Medium', fontSize: '20px', marginTop: '5px' }}
            >
              Submit
            </Button>
          </form>
        </Paper>
      </div>
    </div>
  );
};

export default ClientPortal;
